import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ServiceConfigurationSummary {
  id: string;
  configName: string;
  niceText: string | null;
  stringValue: string | null;
  integerValue: number | null;
  boolValue: boolean | null;
  doubleValue: number | null;
  comment: string | null;
  createdAt: string;
  lastModified: string;
  lastModifiedByName: string | null;
}

export interface ServiceConfigurationUpdateValue {
  stringValue: string | null;
  integerValue: number | null;
  boolValue: boolean | null;
  doubleValue: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceConfigurationService {
  private readonly apiUrl = `${environment.apiUrl}/service-configurations`;

  constructor(private readonly http: HttpClient) {
  }

  list(): Observable<ServiceConfigurationSummary[]> {
    return this.http.get<ServiceConfigurationSummary[]>(this.apiUrl);
  }

  /** Public (no login required) since the toolbar shows the year to every visitor. */
  getCbActionYear(): Observable<{ year: number | null }> {
    return this.http.get<{ year: number | null }>(`${this.apiUrl}/cb-action-year`);
  }

  /** Public (no login required) - the toolbar and landing page both need this before/without a login. */
  getCustomerServiceStatus(): Observable<{ enabled: boolean; message: string | null; maintenanceReloadMinutes?: number }> {
    return this.http.get<{ enabled: boolean; message: string | null; maintenanceReloadMinutes?: number }>(`${this.apiUrl}/customer-service`);
  }

  /** Public (no login required) - the order confirmation also has to show it to anonymous first-time orderers. */
  getCostPerTree(): Observable<{ costPerTree: number | null }> {
    return this.http.get<{ costPerTree: number | null }>(`${this.apiUrl}/cost-per-tree`);
  }

  /** Live-map pan/zoom limits "minLength@minWidth@@maxLength@maxWidth" (login required); blank = not configured. */
  getMapLimits(): Observable<{ mapLimits: string | null }> {
    return this.http.get<{ mapLimits: string | null }>(`${this.apiUrl}/map-limits`);
  }

  update(id: string, request: ServiceConfigurationUpdateValue): Observable<ServiceConfigurationSummary> {
    return this.http.patch<ServiceConfigurationSummary>(`${this.apiUrl}/${id}`, request);
  }
}
